var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.707 23.7071C23.3164 24.0976 22.6833 24.0976 22.2927 23.7071L15.9998 17.4142L9.70696 23.7071C9.31643 24.0976 8.68327 24.0976 8.29274 23.7071C7.90222 23.3166 7.90222 22.6834 8.29274 22.2929L14.5856 16L8.29274 9.7071C7.90222 9.31658 7.90222 8.68342 8.29274 8.29289C8.68327 7.90237 9.31643 7.90237 9.70696 8.29289L15.9998 14.5858L22.2927 8.29289C22.6833 7.90237 23.3164 7.90237 23.707 8.29289C24.0975 8.68342 24.0975 9.31658 23.707 9.70711L17.4141 16L23.707 22.2929C24.0975 22.6834 24.0975 23.3166 23.707 23.7071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.1ee50463108c5c89abfab44f55dc29a2.svg";
export { ForwardRef as ReactComponent };